import { render } from "./PageSignup.vue?vue&type=template&id=589cd9c6"
import script from "./PageSignup.vue?vue&type=script&lang=js"
export * from "./PageSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__